<template>
  <div id={id} class={className}>
    <div class="pswp-thumbnails">
      <div class="c-activity-image-first">
        <a v-if="!video" key="0" @click="showPhotoSwipe($event, 0)" class="c-activity-image">
            <slot :item="items[0]">
                <img :src="items[0].src" alt="picture"/>
            </slot>
        </a>
        <video v-else controls autoplay muted playsinline :poster="items[0].src" crossorigin="anonymous"  preload="metadata">
            <source :src="`${cdnUrl}/activities/videos/`+ video.video" type="video/webm" size="720">
            <a key="0" @click="showPhotoSwipe($event, 0)" class="c-activity-image">
                <slot :item="items[0]">
                    <img :src="items[0].src" alt="picture"/>
                </slot>
            </a>
        </video>
      </div>
      <div class="c-activity-image-other">
        <template :item="item" v-for="(item, index) in items" class="pswp-thumbnail">
          <template v-if="(index > 0 || index == 0 && video) && index < 5 && !((!video && index == 3 && items.length == 4) || (video && index == 2 && items.length == 3) || (video && index > 3))"> 
            <a :key="index"  @click="showPhotoSwipe($event, index)" class="c-activity-image">
                <slot :item="item">
                    <img :src="item.src" alt="picture"/>
                </slot>
            </a>
          </template>
        </template>
      </div>
      <div class="c-activity-image-button">
        <a key="0" @click="showPhotoSwipe($event, 0)">
            {{trans('Show all')}}
        </a>
      </div>
    </div>
    <v-photoswipe
      ref="pswp"
      :isOpen="opened"
      :items="items"
      :options="options"
      @close="handleClose"
    />
  </div>
</template>

<script>
import { PhotoSwipe, events } from 'v-photoswipe'
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';

export default {
  name: 'v-photoswipe-gallery',
  components: {
    'v-photoswipe': PhotoSwipe
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    video: {
      type: Object,
      required: false
    },
    options: {
      type: Object,
      default: {}
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      opened: this.isOpen,
      opts: {}
    }
  },
  watch: {
    isOpen (val, oldVal) {
      if (val !== this.opened) {
        this.opened = val
      }
    }
  },
  methods: {
    showPhotoSwipe (e, index) {
      e.preventDefault()
      this.opts = Object.assign(this.options, {
        index
      })
      this.opened = true
    },
    handleClose () {
      this.opened = false
    }
  },
  computed: {
    tenantId() {
      return window.tenant;
    },
    cdnUrl() {
			return window.cdn_url;
		}
  },
  mounted () {
    if(this.video){
      // Change the second argument to your options:
      // https://github.com/sampotts/plyr/#options
      const player = new Plyr('video', {
        ratio: '3:2',
        controls: ['play', 'progress', 'current-time', 'mute','airplay','pip', 'fullscreen'],
      });
      // Expose player so it can be used from the console
      window.player = player;

    }
    

    // events.forEach(e => {
    //   this.$refs.pswp.$on(e, (...args) => {
    //     args.unshift(this)
    //     this.$emit(e, [...args])
    //   })
    // })
  }
}
</script>

<style lang="css">
  :root{
      --plyr-color-main: #0078cc;
  }
  .pswp-thumbnails .pswp-thumbnail {
    font-size: 0;
    cursor: pointer;
  }
  .plyr--video {
    /* height: 100%; */
  }
</style>